export const fmtMoney = (n: number) =>
  (isNaN(n) ? 0 : n).toLocaleString("es-CO", {
    style: "currency",
    currency: "COP",
    maximumFractionDigits: 0,
  });
